class HorizontalSwiper extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const direction = this.getAttribute('data-direction');
    const reverseDirection = direction == 'reverse' ? true : false;
    const swiper = new Swiper(this, {
      loop: true,
      centeredSlides: true,
      autoplay: {
        delay: 0,
        allowTouchMove: false,
        disableOnInteraction: false,
      },
      speed: 6000,
      slidesPerView: 'auto',
    });
  }
}

customElements.define('swiper-marquee', HorizontalSwiper);
